import { Button, Spin } from "antd";

type Props = {
  /** More rows are being appended to the browse list (infinite scroll). */
  loadingMore: boolean;
  /** The last page fetch failed. */
  error: boolean;
  retry: () => void;
};

/**
 * Shared infinite-scroll footer for the client picker dropdowns: a spinner while the next page
 * loads, an inline error + Retry when a page fails, nothing at the end of the list. Mirrors the
 * sidebar's footer states so every surface reads the same.
 */
const PickerListFooter = ({ loadingMore, error, retry }: Props) => {
  if (loadingMore) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "8px 0" }}>
        <Spin size="small" />
        <span style={{ color: "#8c8c8c" }}>Loading more…</span>
      </div>
    );
  }
  if (error) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "8px 0" }}>
        <span style={{ color: "#cf1322" }}>⚠ Couldn't load more.</span>
        <Button type="link" size="small" style={{ padding: 0 }} onClick={retry}>
          Retry
        </Button>
      </div>
    );
  }
  return null;
};

export default PickerListFooter;
